module.exports = __webpack_public_path__ + "static/media/ug.c94bc7a8.svg";